import React from 'react';
export function Label({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <span className={`font-mono text-[12px] tracking-[0.18em] uppercase text-brand-gray600 ${className}`} data-id="element-79" data-mp="2w4rvfxodj1r5">
      {children}
    </span>;
}